import { call, put, takeLatest } from 'redux-saga/effects'

import { showError } from 'src/store/ducks/error'
import { addLoading, removeLoading } from 'src/store/ducks/loading'
import { AxiosServerResponse, ANALYSIS_ROUTES, Server } from 'src/services'

import { ANALYSIS } from './types'
import { setAnalysisList } from './actions'

export function* requestFetchAnalysisWatcher() {
  yield takeLatest(ANALYSIS.REQUEST_FETCH_ANALYSIS, handleFetchAnalysis)
}

export function* handleFetchAnalysis() {
  try {
    yield put(addLoading(ANALYSIS.REQUEST_FETCH_ANALYSIS))

    const { data }: AxiosServerResponse<UncDashboard.Analysis> = yield call(
      Server.put,
      ANALYSIS_ROUTES.GET_POR_CAMPOS,
      {},
    )

    if (data.isSuccessful) {
      yield put(setAnalysisList(data.data))
    } else {
      yield put(setAnalysisList([]))
    }
  } catch (e) {
    if (e instanceof Error) {
      yield put(showError(e.message ? [e.message] : []))
    } else {
      yield put(showError(['An unknown error occurred.']))
    }
  } finally {
    yield put(removeLoading(ANALYSIS.REQUEST_FETCH_ANALYSIS))
  }
}
